import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import "../static/css/labelStudio.css";
import 'element-ui/lib/theme-chalk/index.css'
import UmyUi from 'umy-ui'
import './util/dire.js'
import GetUrl from './util/GetUrl';
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import Stick from 'vue-stick'
import tinymce from 'tinymce';
import 'umy-ui/lib/theme-chalk/index.css';// 引入样式
import '../static/css/common.css'
import './assets/iconfont/iconfont.css'
import '@/assets/css/dark.min.css'
import VueContextMenu from 'vue-contextmenu'
import TipsDialog from '../src/components/tipsDialog/index'
import EmptyData from '../src/components/emptyData/index'
import splitPane from 'vue-splitpane'
//import 'animate.css';
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import vuescroll from "vuescroll";

import './assets/js/directive'
import filters from "./filters/index";
Vue.config.productionTip = false
Vue.prototype.$tinymce = tinymce;
// 全局过滤器
Object.keys(filters).map(value => {
  Vue.filter(value, filters[value]);
})
// 富文本编辑器
Vue.use(VueQuillEditor);
import utils from "./util/utils.js";
Vue.prototype.$utils = utils;
Vue.prototype.$GetUrl = GetUrl;

//语言类型js
import i18n from './components/lang'
// console.log(i18n)
Vue.use(ElementUI, {
  i18n: (key, value) => {
    return i18n.t(key, value)
  }
});

// 滚动条美化  https://vuescrolljs.yvescoding.org/zh/guide/configuration.html
Vue.use(vuescroll, {
	// 在这里设置全局默认配置
	ops: {
		bar: {
			background: "#cecece",
			onlyShowBarOnScroll: false,
			opacity: 0.5
		},
		scrollPanel: {
			scrollingX: false
		}
	}
});

Vue.use(Stick);

Vue.use(VXETable)
Vue.component('EmptyData', EmptyData)
Vue.use(TipsDialog)
Vue.use(UmyUi);
Vue.component('split-pane', splitPane);
Vue.use(VueContextMenu)
Vue.prototype.$bus = new Vue();

// 报错
Vue.prototype.$messageError = (name) => {
  ElementUI.Message.error({
    showClose: true,
    message: typeof (name) == "string" ? name : '出错啦，请稍后重试'
  })
}
// 成功
Vue.prototype.$messageSuccess = (name) => {
  ElementUI.Message.success({
    showClose: true,
    message: name
  })
}
// 警告
Vue.prototype.$messageWarning = (name) => {
  ElementUI.Message.warning({
    showClose: true,
    message: name
  })
}
// 消息
Vue.prototype.$messageInfo = (name) => {
  ElementUI.Message.info({
    showClose: true,
    message: name
  })
}

Vue.directive('has', {
  inserted: function (el, binding) {
    if (!Vue.prototype.$_has(binding.value)) {
      el.parentNode.removeChild(el)
    }
  }
})
Vue.prototype.$_has = function (value) {
  let isExist = false
  var btnpermsStr = JSON.parse(sessionStorage.getItem('btnPerms'))
  if (
    btnpermsStr === undefined ||
    btnpermsStr == null ||
    btnpermsStr.length == 0
  ) {
    return false
  }
  for (let i = 0; i < btnpermsStr.length; i++) {
    if (btnpermsStr[i] == value) {
      // 若在按钮中定义的权限字段能在后端返回的权限数组中能找到，则该按钮可显示
      isExist = true
      break
    }
  }
  return isExist
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js